import dialogType from '../../../../display/dialogs/dialogType'

import api from '../../../../configs/api'

const museumType =
{
    title : 'Types' ,
    edit  :
    {
        agree       : 'Enregistrer' ,
        description : 'Sélectionner des types dans la liste ci-dessous.',
        disagree    : 'Annuler' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...',
        refresh     : 'Charger',
        success     : 'Mise à jour réussie!' ,
        title       : 'Types' ,
        uri         : api.thesaurus.museums_types,
        type        : dialogType.THESAURUS_CHECKER
    },
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Modifier" ,
        remove : "Supprimer"
    }
};

export default museumType ;